import { IRHookFormMaskedTextField, LabelPosition, RHookFormMaskedTextField } from '@websential/cosmic-v20';
import React, { FC } from 'react';

import { FieldLayout } from './FieldLayout';
import { GridSize } from '@mui/material';

/**
 * Text fields allow users to enter text into a UI. They typically appear in forms and dialogs.
 * The EnhancedTextInputWR wrapper component is a complete form control using Material UI TextField including
 * a label, input, and help text. Websential is using the outlined variants.
 */
interface LayoutWithLabel {
  /**
   * The label content.
   */
  label: React.ReactNode;
  /**
   * If true, the '*' sign is displayed as required.
   */
  required?: boolean;
  /**
   * Set the position of label on the top or left of the input
   */
  labelPosition?: LabelPosition;
  /**
   * Defines the number of grids the label is going to use.  
   */
  labelColumns?: GridSize;
  /**
    * Defines the number of grids the field is going to use. 
    */
  fieldColumns?: GridSize;
}
export interface IRHookFormMaskedTextFieldWithVerifyLabel extends IRHookFormMaskedTextField, LayoutWithLabel { }

export const RHookFormMaskedTextFieldWithVerifyLabel: FC<IRHookFormMaskedTextFieldWithVerifyLabel> = ({
  id,
  label,
  required,
  labelPosition = LabelPosition.Top,
  labelColumns = 4,
  fieldColumns = 8,
  // inputAdornment = false,
  // inputAdornmentText = "",
  inputMaskPattern = "",
  field,
  testId,
  placeholder = "",
  defaultValue,
  uppercase = false,
  readOnly = false,
}: IRHookFormMaskedTextFieldWithVerifyLabel) => {

  // The destructuring of field prop preventing some TypeScript error with the MaskedInput field.
  // DO NOT REMOVE IT
  return (
    <FieldLayout
      label={label}
      isRequired={required}
      testId={testId}
      labelPosition={labelPosition}
      labelColumns={labelColumns}
      fieldColumns={fieldColumns}
    >
      <RHookFormMaskedTextField
        id={id}
        defaultValue={defaultValue}
        placeholder={placeholder}
        inputMaskPattern={inputMaskPattern}
        field={field}
        testId={id}
        uppercase={uppercase}
        readOnly={readOnly}
      />
    </FieldLayout>
  );
};
